export const BOOKING_ENGINE_EDITOR_LANGUAGE_OPTIONS = Object.freeze([
  { id: "en", label: "English", shortLabel: "EN" },
  { id: "es", label: "Spanish", shortLabel: "ES" },
]);

export const BOOKING_ENGINE_EMAIL_PREVIEW_VARS = Object.freeze({
  HotelName: "Pilcore Grand Hotel",
  GuestName: "Alex Turner",
  GuestEmail: "alex.turner@example.com",
  BookingReference: "PGH-20481",
  CheckInDate: "2026-07-18",
  CheckOutDate: "2026-07-21",
  RoomsCount: "2",
  TotalPrice: "1248.00",
  NightlyPrices: [
    "Room 1 - Deluxe Double - Flexible Rate",
    "  2026-07-18: EUR 399.00",
    "  2026-07-19: EUR 425.00",
    "",
    "Room 2 - Deluxe Double - Flexible Rate",
    "  2026-07-20: EUR 424.00",
  ].join("\n"),
  CancelUrl: "https://pilcore.example.com/manage/cancel/PGH-20481",
});

const BOOKING_ENGINE_STEP_MESSAGES = {
  en: {
    eyebrow: "Direct sales setup",
    title: "Booking Engine",
    copy:
      "Prepare the staged direct-booking experience now. Nothing from this step goes live until an admin applies the onboarding draft.",
    contractTitle: "Contract locked by admin",
    contractCopy:
      "This hotel was prepared with Pilcore Booking Engine included. You can configure the guest-facing experience here, but the final publish still depends on admin approval.",
    contractTag: "Included",
    launchTitle: "Public URL",
    launchCopy:
      "Reserve the direct-booking slug now so the final URL is ready for the website, QR codes and campaigns once the admin approves the draft.",
    slugLabel: "Public URL slug",
    slugHint: "Lowercase letters, numbers and dashes only.",
    slugPlaceholder: "hotel-roma",
    urlLabel: "Preview URL",
    urlEmpty: "Add a slug to preview the final URL.",
    urlHint: "This is only a preview while the onboarding draft stays staged.",
    profileTitle: "Public hotel info",
    profileCopy:
      "This identity block appears inside the Booking Engine and should feel polished before the draft is approved.",
    profilePreviewTitle: "Booking panel preview",
    profilePreviewHint: "Guests will see this summary while booking.",
    profileHotelName: "Public hotel name",
    profileAddressLine: "Address line",
    profileCity: "City",
    profilePostalCode: "Postal code",
    profileCountry: "Country",
    profilePhones: "Phones",
    profileEmails: "Emails",
    heroTitle: "Hero visual and promise",
    heroCopy:
      "Upload the hero background and define the opening promise in English and Spanish.",
    heroBackgroundLabel: "Hero background",
    heroBackgroundHint: "Recommended: 1920x1080 or larger in landscape format.",
    heroBackgroundLocked: "Remove the current hero image first if you want to replace it.",
    heroPreviewTitle: "Hero preview",
    heroPreviewEmpty: "No hero image uploaded yet.",
    heroSubtitleLabel: "Hero subtitle",
    heroClaimLabel: "Hero claim",
    heroSubtitlePlaceholderEn: "Your stay starts here",
    heroSubtitlePlaceholderEs: "Tu estancia empieza aqui",
    heroClaimPlaceholderEn: "Real availability - Best rate guaranteed - No prepayment",
    heroClaimPlaceholderEs: "Disponibilidad real - Mejor precio garantizado - Sin prepago",
    pricingTitle: "Price disclosure",
    pricingCopy:
      "Clarify what is included in the price the guest sees before payment.",
    pricingSummaryTitle: "How it will read",
    pricingVat: "Including VAT",
    pricingOtherTaxes: "Including other taxes",
    pricingFees: "Including fees",
    pricingCityTax: "Including city tax",
    pricingVatLabel: "VAT",
    pricingOtherTaxesLabel: "other taxes",
    pricingFeesLabel: "fees",
    pricingCityTaxLabel: "city tax",
    pricingTotalLabel: "TOTAL (ALL ROOMS)",
    pricingIncludingPrefix: "Including",
    pricingConjunction: "and",
    pricingNoneIncluded: "Not including any taxes or fees",
    pricingAllIncluded: "All taxes and fees included",
    emailsTitle: "Guest confirmation email",
    emailsCopy:
      "Prepare the direct-booking confirmation message in both languages. Tokens are resolved automatically when the email is sent from the final live setup.",
    emailSubjectLabel: "Subject",
    emailBodyLabel: "Body",
    emailPreviewTitle: "Rendered preview",
    emailVariablesTitle: "Tokens",
    emailVariablesHint: "Click any token to insert it into the last focused field.",
    emailEmptyPreview: "Nothing written yet for this language.",
    emailBodyHint:
      "{{NightlyPrices}} expands one line per night and {{CancelUrl}} becomes available when the final live flow supports it.",
    termsTitle: "Booking terms and conditions",
    termsCopy:
      "Keep the staged clauses organized now so the admin can approve a complete legal flow later.",
    termsAdd: "Add term",
    termSortOrder: "Sort order",
    termTitleEn: "Title (EN)",
    termTitleEs: "Title (ES)",
    termTextEn: "Text (EN)",
    termTextEs: "Text (ES)",
    termEmpty: "No terms added yet.",
    roomsTitle: "Room-category storytelling",
    roomsCopy:
      "Each staged room category can already carry its selling images, amenities and commercial text before the admin applies the onboarding draft.",
    roomsLoading: "Loading room categories...",
    roomsEmpty: "No staged room categories are available yet.",
    roomImagesTab: "Images",
    roomAmenitiesTab: "Amenities",
    roomCopyTab: "Commercial copy",
    roomImagesLabel: "Images",
    roomImageHint: "Upload as cover or gallery. Maximum 10 images per room category.",
    roomNoImage: "No images uploaded yet.",
    roomUploadCover: "Upload as cover",
    roomUploadGallery: "Upload to gallery",
    roomMaxImages: "Maximum 10 images reached",
    roomNoFile: "No file selected",
    roomCoverTag: "Cover",
    roomGalleryTag: "Gallery",
    roomAmenitiesTitle: "Room amenities",
    roomAmenitiesHint: "Pick the amenities that guests should see in the Booking Engine.",
    roomAmenitiesSearch: "Search amenities...",
    roomAmenitiesAllCategories: "All categories",
    roomAmenitiesSelected: "Selected amenities",
    roomNoAmenities: "No amenities selected yet.",
    roomNoAmenitiesMatch: "No amenities match the current filters.",
    roomClearAmenities: "Clear selection",
    roomCopyTitle: "Commercial copy",
    roomCopyHint:
      "Fill both languages so guests see a convincing room story on the public booking page after admin approval.",
    roomCopyPreviewTitle: "Booking Engine preview",
    roomCopyPreviewHint: "This is how the room card is expected to look for the selected language.",
    roomCopyNameEn: "Name (EN)",
    roomCopyNameEs: "Name (ES)",
    roomCopyShortEn: "Short description (EN)",
    roomCopyShortEs: "Short description (ES)",
    roomCopySize: "Size (m2)",
    roomCopyBeds: "Beds",
    roomCopyMaxPax: "Max pax",
    roomCopyBedTypeEn: "Bed type (EN)",
    roomCopyBedTypeEs: "Bed type (ES)",
    roomCopyViewEn: "View (EN)",
    roomCopyViewEs: "View (ES)",
    roomCopyHighlightsEn: "Highlights (EN)",
    roomCopyHighlightsEs: "Highlights (ES)",
    roomCopyPreviewLanguage: "Preview language",
    roomCopyPreviewEmpty: "Add commercial text to shape this room card.",
    roomCopyBedTypeLabel: "Bed type",
    roomCopyViewLabel: "View",
    roomCopyHighlightsLabel: "Highlights",
    summaryTitle: "Staged snapshot",
    summaryIntro:
      "This step prepares everything the admin needs to approve the Booking Engine rollout later.",
    summaryPoints: [
      "Uploads stay in onboarding staging until admin apply.",
      "Slug, hero, emails and room storytelling can be refined before go-live.",
      "Room images are staged here so the final approval can publish the full commercial setup.",
    ],
    summarySlugLabel: "Slug",
    summaryHeroLabel: "Hero",
    summaryTermsLabel: "Terms",
    summaryEmailsLabel: "Email languages",
    summaryRoomsLabel: "Room categories",
    summaryImagesLabel: "Room images",
    summaryAmenitiesLabel: "Selected amenities",
    summarySavedLabel: "Last save",
    summaryNotSaved: "Not saved yet",
    statusReady: "Ready",
    statusPending: "Pending",
    statusConfigured: "Configured",
    statusMissing: "Missing",
    actions: {
      upload: "Upload",
      uploading: "Uploading...",
      remove: "Remove",
      setAsCover: "Set as cover",
      copyUrl: "Copy URL",
      addPhone: "Add phone",
      addEmail: "Add email",
      addTerm: "Add term",
    },
    toasts: {
      loadError: "We could not load the staged Booking Engine draft.",
      saveSuccess: "Booking Engine onboarding draft saved.",
      saveError: "The Booking Engine onboarding draft could not be saved.",
      urlCopied: "Preview URL copied to the clipboard.",
      urlCopyError: "The preview URL could not be copied.",
      pickImageFirst: "Select an image first.",
      heroAlreadyExists: "A hero image already exists. Remove it first.",
      heroUploaded: "Hero image uploaded to onboarding staging.",
      heroRemoved: "Hero image removed from onboarding staging.",
      heroError: "The hero image action failed.",
      imageUploaded: "Room image uploaded to onboarding staging.",
      imageRemoved: "Room image removed from onboarding staging.",
      imageCoverUpdated: "Cover image updated in onboarding staging.",
      imageError: "The room image action failed.",
      roomCopyMissingNames: "Name EN and Name ES are required for each room category copy.",
    },
  },
  es: {
    eyebrow: "Configuracion de venta directa",
    title: "Booking Engine",
    copy:
      "Prepara ahora la experiencia de reserva directa en staging. Nada de este paso pasa a live hasta que un admin aplique el borrador del onboarding.",
    contractTitle: "Contratacion fijada por admin",
    contractCopy:
      "Este hotel fue preparado con Pilcore Booking Engine incluido. Aqui puedes dejar lista la experiencia para el huesped, pero la publicacion final sigue dependiendo de la aprobacion del admin.",
    contractTag: "Incluido",
    launchTitle: "URL publica",
    launchCopy:
      "Reserva ahora el slug de venta directa para que la URL final quede lista para web, QR y campanas cuando el admin apruebe el borrador.",
    slugLabel: "Slug publico",
    slugHint: "Solo minusculas, numeros y guiones.",
    slugPlaceholder: "hotel-roma",
    urlLabel: "Vista previa de URL",
    urlEmpty: "Anade un slug para previsualizar la URL final.",
    urlHint: "Esto es solo una vista previa mientras el borrador siga en staging.",
    profileTitle: "Informacion publica del hotel",
    profileCopy:
      "Este bloque de identidad aparece dentro del Booking Engine y conviene dejarlo pulido antes de la aprobacion.",
    profilePreviewTitle: "Preview del panel de reserva",
    profilePreviewHint: "El huesped vera este resumen mientras reserva.",
    profileHotelName: "Nombre publico del hotel",
    profileAddressLine: "Direccion",
    profileCity: "Ciudad",
    profilePostalCode: "Codigo postal",
    profileCountry: "Pais",
    profilePhones: "Telefonos",
    profileEmails: "Emails",
    heroTitle: "Hero visual y promesa comercial",
    heroCopy:
      "Sube la imagen hero y define el mensaje de apertura en ingles y espanol.",
    heroBackgroundLabel: "Imagen hero",
    heroBackgroundHint: "Recomendado: 1920x1080 o mas, en horizontal.",
    heroBackgroundLocked: "Elimina antes la hero actual si quieres sustituirla.",
    heroPreviewTitle: "Preview hero",
    heroPreviewEmpty: "Todavia no hay hero subida.",
    heroSubtitleLabel: "Subtitulo hero",
    heroClaimLabel: "Claim hero",
    heroSubtitlePlaceholderEn: "Your stay starts here",
    heroSubtitlePlaceholderEs: "Tu estancia empieza aqui",
    heroClaimPlaceholderEn: "Real availability - Best rate guaranteed - No prepayment",
    heroClaimPlaceholderEs: "Disponibilidad real - Mejor precio garantizado - Sin prepago",
    pricingTitle: "Desglose del precio",
    pricingCopy:
      "Aclara que esta incluido en el precio que el huesped vera antes del pago.",
    pricingSummaryTitle: "Asi se leeria",
    pricingVat: "Incluyendo IVA",
    pricingOtherTaxes: "Incluyendo otros impuestos",
    pricingFees: "Incluyendo fees",
    pricingCityTax: "Incluyendo city tax",
    pricingVatLabel: "IVA",
    pricingOtherTaxesLabel: "otros impuestos",
    pricingFeesLabel: "fees",
    pricingCityTaxLabel: "city tax",
    pricingTotalLabel: "TOTAL (TODAS LAS HABITACIONES)",
    pricingIncludingPrefix: "Incluyendo",
    pricingConjunction: "y",
    pricingNoneIncluded: "Sin incluir impuestos ni fees",
    pricingAllIncluded: "Todos los impuestos y fees incluidos",
    emailsTitle: "Email de confirmacion al huesped",
    emailsCopy:
      "Prepara el mensaje de confirmacion de reserva directa en ambos idiomas. Los tokens se resolveran automaticamente cuando exista el flujo live final.",
    emailSubjectLabel: "Asunto",
    emailBodyLabel: "Cuerpo",
    emailPreviewTitle: "Preview renderizado",
    emailVariablesTitle: "Tokens",
    emailVariablesHint: "Haz clic en un token para insertarlo en el ultimo campo enfocado.",
    emailEmptyPreview: "Todavia no hay contenido para este idioma.",
    emailBodyHint:
      "{{NightlyPrices}} expande una linea por noche y {{CancelUrl}} estara disponible cuando el flujo live final lo soporte.",
    termsTitle: "Terminos y condiciones",
    termsCopy:
      "Deja ordenadas ahora las clausulas en staging para que el admin pueda aprobar despues un flujo legal completo.",
    termsAdd: "Anadir termino",
    termSortOrder: "Orden",
    termTitleEn: "Titulo (EN)",
    termTitleEs: "Titulo (ES)",
    termTextEn: "Texto (EN)",
    termTextEs: "Texto (ES)",
    termEmpty: "Todavia no hay terminos anadidos.",
    roomsTitle: "Storytelling por categoria",
    roomsCopy:
      "Cada categoria de habitacion en staging ya puede llevar sus imagenes de venta, amenities y copy comercial antes del apply del admin.",
    roomsLoading: "Cargando categorias de habitacion...",
    roomsEmpty: "Todavia no hay categorias de habitacion en staging.",
    roomImagesTab: "Imagenes",
    roomAmenitiesTab: "Amenities",
    roomCopyTab: "Copy comercial",
    roomImagesLabel: "Imagenes",
    roomImageHint: "Sube como cover o galeria. Maximo 10 imagenes por categoria.",
    roomNoImage: "Todavia no hay imagenes subidas.",
    roomUploadCover: "Subir como cover",
    roomUploadGallery: "Subir a galeria",
    roomMaxImages: "Se ha alcanzado el maximo de 10 imagenes",
    roomNoFile: "No hay archivo seleccionado",
    roomCoverTag: "Cover",
    roomGalleryTag: "Galeria",
    roomAmenitiesTitle: "Amenities de la habitacion",
    roomAmenitiesHint: "Marca las amenities que deben ver los huespedes en el Booking Engine.",
    roomAmenitiesSearch: "Buscar amenities...",
    roomAmenitiesAllCategories: "Todas las categorias",
    roomAmenitiesSelected: "Amenities seleccionadas",
    roomNoAmenities: "Todavia no hay amenities seleccionadas.",
    roomNoAmenitiesMatch: "No hay amenities que coincidan con los filtros actuales.",
    roomClearAmenities: "Vaciar seleccion",
    roomCopyTitle: "Copy comercial",
    roomCopyHint:
      "Rellena ambos idiomas para que el huesped vea una historia de venta convincente en la pagina publica tras la aprobacion del admin.",
    roomCopyPreviewTitle: "Preview de Booking Engine",
    roomCopyPreviewHint: "Asi se espera que se vea la card de la habitacion para el idioma elegido.",
    roomCopyNameEn: "Nombre (EN)",
    roomCopyNameEs: "Nombre (ES)",
    roomCopyShortEn: "Descripcion corta (EN)",
    roomCopyShortEs: "Descripcion corta (ES)",
    roomCopySize: "Tamano (m2)",
    roomCopyBeds: "Camas",
    roomCopyMaxPax: "Max pax",
    roomCopyBedTypeEn: "Tipo de cama (EN)",
    roomCopyBedTypeEs: "Tipo de cama (ES)",
    roomCopyViewEn: "Vista (EN)",
    roomCopyViewEs: "Vista (ES)",
    roomCopyHighlightsEn: "Highlights (EN)",
    roomCopyHighlightsEs: "Highlights (ES)",
    roomCopyPreviewLanguage: "Idioma preview",
    roomCopyPreviewEmpty: "Anade copy comercial para dar forma a esta card.",
    roomCopyBedTypeLabel: "Tipo de cama",
    roomCopyViewLabel: "Vista",
    roomCopyHighlightsLabel: "Highlights",
    summaryTitle: "Resumen en staging",
    summaryIntro:
      "Este paso deja preparado todo lo que el admin necesitara para aprobar despues el despliegue del Booking Engine.",
    summaryPoints: [
      "Las subidas se quedan en staging de onboarding hasta el apply del admin.",
      "Slug, hero, emails y storytelling de habitaciones se pueden refinar antes del go-live.",
      "Las imagenes de habitaciones quedan preparadas aqui para que la aprobacion final publique todo el setup comercial.",
    ],
    summarySlugLabel: "Slug",
    summaryHeroLabel: "Hero",
    summaryTermsLabel: "Terminos",
    summaryEmailsLabel: "Idiomas email",
    summaryRoomsLabel: "Categorias",
    summaryImagesLabel: "Imagenes",
    summaryAmenitiesLabel: "Amenities seleccionadas",
    summarySavedLabel: "Ultimo guardado",
    summaryNotSaved: "Todavia sin guardar",
    statusReady: "Listo",
    statusPending: "Pendiente",
    statusConfigured: "Configurado",
    statusMissing: "Sin configurar",
    actions: {
      upload: "Subir",
      uploading: "Subiendo...",
      remove: "Eliminar",
      setAsCover: "Poner como cover",
      copyUrl: "Copiar URL",
      addPhone: "Anadir telefono",
      addEmail: "Anadir email",
      addTerm: "Anadir termino",
    },
    toasts: {
      loadError: "No hemos podido cargar el borrador staged del Booking Engine.",
      saveSuccess: "Borrador del Booking Engine guardado.",
      saveError: "No se ha podido guardar el borrador del Booking Engine.",
      urlCopied: "La URL preview se ha copiado al portapapeles.",
      urlCopyError: "No se ha podido copiar la URL preview.",
      pickImageFirst: "Selecciona primero una imagen.",
      heroAlreadyExists: "Ya existe una hero subida. Eliminala antes.",
      heroUploaded: "Hero subida a staging.",
      heroRemoved: "Hero eliminada de staging.",
      heroError: "La accion sobre la hero ha fallado.",
      imageUploaded: "Imagen de habitacion subida a staging.",
      imageRemoved: "Imagen de habitacion eliminada de staging.",
      imageCoverUpdated: "La imagen cover se ha actualizado en staging.",
      imageError: "La accion sobre la imagen de habitacion ha fallado.",
      roomCopyMissingNames: "Nombre EN y Nombre ES son obligatorios para el copy de cada categoria.",
    },
  },
};

function isObject(value) {
  return value && typeof value === "object" && !Array.isArray(value);
}

function normalizeIdArray(values) {
  return Array.isArray(values)
    ? values
        .map((value) => Number(value))
        .filter((value, index, array) => Number.isInteger(value) && value > 0 && array.indexOf(value) === index)
    : [];
}

function normalizeStringArray(values, objectKeys = []) {
  if (!Array.isArray(values)) return [];
  return values
    .map((value) => {
      if (typeof value === "string") return value;
      if (!value || typeof value !== "object") return "";
      for (const key of objectKeys) {
        if (value?.[key] != null && String(value[key]).trim()) {
          return String(value[key]).trim();
        }
      }
      return "";
    })
    .map((value) => String(value || "").trim())
    .filter(Boolean);
}

export function getBookingEngineStepMessages(languageId) {
  const normalized = String(languageId || "").toLowerCase();
  if (normalized.startsWith("es") || normalized.startsWith("ca")) {
    return BOOKING_ENGINE_STEP_MESSAGES.es;
  }
  return BOOKING_ENGINE_STEP_MESSAGES.en;
}

export function createEmptyBookingEngineDraft() {
  return {
    booking_engine_enabled: true,
    booking_engine_slug: "",
    booking_engine_texts: {
      hero_subtitle: { en: "", es: "" },
      hero_claim: { en: "", es: "" },
    },
    booking_engine_terms: [],
    booking_engine_guest_email_templates: {
      en: { subject: "", body: "" },
      es: { subject: "", body: "" },
    },
    booking_engine_price_includes_vat: false,
    booking_engine_price_includes_other_taxes: false,
    booking_engine_price_includes_fees: false,
    booking_engine_price_includes_city_tax: false,
  };
}

export function ensureBookingEngineGuestEmailTemplates(source) {
  const rawTemplates = isObject(source?.booking_engine_guest_email_templates)
    ? source.booking_engine_guest_email_templates
    : isObject(source)
      ? source
      : {};
  return {
    en: {
      subject: String(rawTemplates?.en?.subject || "").trim(),
      body: String(rawTemplates?.en?.body || "").trim(),
    },
    es: {
      subject: String(rawTemplates?.es?.subject || "").trim(),
      body: String(rawTemplates?.es?.body || "").trim(),
    },
  };
}

export function createBookingEngineTerm(seed = {}) {
  return {
    id: seed.id != null ? String(seed.id) : `term_${Date.now()}_${Math.round(Math.random() * 1000)}`,
    sort_order: Number(seed.sort_order) || 0,
    title: {
      en: String(seed?.title?.en || "").trim(),
      es: String(seed?.title?.es || "").trim(),
    },
    text: {
      en: String(seed?.text?.en || "").trim(),
      es: String(seed?.text?.es || "").trim(),
    },
  };
}

export function normalizeBookingEngineTerms(value) {
  return Array.isArray(value) ? value.filter(Boolean).map((item) => createBookingEngineTerm(item)) : [];
}

export function normalizeBookingEngineDraft(rawDraft) {
  const base = createEmptyBookingEngineDraft();
  const source = isObject(rawDraft) ? rawDraft : {};
  const bookingEngineTexts = isObject(source.booking_engine_texts) ? source.booking_engine_texts : {};

  return {
    ...base,
    booking_engine_enabled: true,
    booking_engine_slug: String(source.booking_engine_slug || "")
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, ""),
    booking_engine_texts: {
      hero_subtitle: {
        en: String(bookingEngineTexts?.hero_subtitle?.en || "").trim(),
        es: String(bookingEngineTexts?.hero_subtitle?.es || "").trim(),
      },
      hero_claim: {
        en: String(bookingEngineTexts?.hero_claim?.en || "").trim(),
        es: String(bookingEngineTexts?.hero_claim?.es || "").trim(),
      },
    },
    booking_engine_terms: normalizeBookingEngineTerms(source.booking_engine_terms),
    booking_engine_guest_email_templates: ensureBookingEngineGuestEmailTemplates(source),
    booking_engine_price_includes_vat: Boolean(source.booking_engine_price_includes_vat),
    booking_engine_price_includes_other_taxes: Boolean(source.booking_engine_price_includes_other_taxes),
    booking_engine_price_includes_fees: Boolean(source.booking_engine_price_includes_fees),
    booking_engine_price_includes_city_tax: Boolean(source.booking_engine_price_includes_city_tax),
  };
}

export function createEmptyBookingEngineProfile() {
  return {
    public_hotel_name: "",
    address_line: "",
    city: "",
    postal_code: "",
    country: "",
    phones: [],
    emails: [],
  };
}

export function normalizeBookingEngineProfile(rawProfile) {
  const base = createEmptyBookingEngineProfile();
  const source = isObject(rawProfile) ? rawProfile : {};
  return {
    ...base,
    public_hotel_name: String(source.public_hotel_name || "").trim(),
    address_line: String(source.address_line || "").trim(),
    city: String(source.city || "").trim(),
    postal_code: String(source.postal_code || "").trim(),
    country: String(source.country || "").trim(),
    phones: normalizeStringArray(source.phones, ["value", "phone", "number"]),
    emails: normalizeStringArray(source.emails, ["value", "email", "address"]),
  };
}

export function normalizeBookingEngineAsset(rawAsset) {
  const source = isObject(rawAsset) ? rawAsset : null;
  if (!source) return null;
  const assetId = Number(source.asset_id || source.id || 0);
  const publicUrl = String(source.public_url || source.url || "").trim();
  if (!assetId && !publicUrl) return null;
  return {
    id: assetId || null,
    asset_id: assetId || null,
    kind: String(source.kind || "").trim().toLowerCase(),
    public_url: publicUrl,
    onboarding_room_category_id:
      Number(source.onboarding_room_category_id || source.room_category_id || source.entity_id || 0) || null,
  };
}

export function sortBookingEngineImages(values) {
  return (Array.isArray(values) ? values : [])
    .filter(Boolean)
    .slice()
    .sort((first, second) => {
      if (first.kind === "cover" && second.kind !== "cover") return -1;
      if (first.kind !== "cover" && second.kind === "cover") return 1;
      return Number(second.asset_id || second.id || 0) - Number(first.asset_id || first.id || 0);
    });
}

export function normalizeBookingEngineRoomImages(input) {
  if (!input) return {};

  if (Array.isArray(input)) {
    return input.reduce((accumulator, item) => {
      const asset = normalizeBookingEngineAsset(item);
      const categoryId = Number(
        item?.onboarding_room_category_id || item?.room_category_id || item?.entity_id || asset?.onboarding_room_category_id || 0
      );
      if (!asset || !categoryId) return accumulator;
      const current = accumulator[categoryId] || [];
      accumulator[categoryId] = sortBookingEngineImages([...current, asset]);
      return accumulator;
    }, {});
  }

  if (isObject(input)) {
    return Object.entries(input).reduce((accumulator, [key, value]) => {
      const categoryId = Number(key);
      if (!categoryId) return accumulator;
      accumulator[categoryId] = sortBookingEngineImages(
        (Array.isArray(value) ? value : []).map((item) =>
          normalizeBookingEngineAsset({
            ...item,
            onboarding_room_category_id: item?.onboarding_room_category_id || categoryId,
          })
        )
      ).filter(Boolean);
      return accumulator;
    }, {});
  }

  return {};
}

export function normalizeBookingEngineRoomCopyRow(row) {
  if (!isObject(row)) return null;
  const categoryId = Number(row.onboarding_room_category_id || row.room_category_id || 0);
  return {
    id: Number(row.id || 0) || null,
    onboarding_room_category_id: categoryId || null,
    name_en: String(row.name_en || "").trim(),
    name_es: String(row.name_es || "").trim(),
    short_description_en: row.short_description_en == null ? "" : String(row.short_description_en).trim(),
    short_description_es: row.short_description_es == null ? "" : String(row.short_description_es).trim(),
    size_m2: row.size_m2 == null || row.size_m2 === "" ? "" : String(row.size_m2).trim(),
    beds_count: row.beds_count == null || row.beds_count === "" ? "" : String(row.beds_count).trim(),
    max_pax: row.max_pax == null || row.max_pax === "" ? "" : String(row.max_pax).trim(),
    bed_type_en: row.bed_type_en == null ? "" : String(row.bed_type_en).trim(),
    bed_type_es: row.bed_type_es == null ? "" : String(row.bed_type_es).trim(),
    view_en: row.view_en == null ? "" : String(row.view_en).trim(),
    view_es: row.view_es == null ? "" : String(row.view_es).trim(),
    highlights_en: row.highlights_en == null ? "" : String(row.highlights_en).trim(),
    highlights_es: row.highlights_es == null ? "" : String(row.highlights_es).trim(),
  };
}

export function buildDefaultBookingEngineRoomCopy(category) {
  const categoryId = Number(category?.id || 0) || null;
  const defaultName = String(category?.name || "").trim() || `Room category ${categoryId || ""}`.trim();
  return {
    id: null,
    onboarding_room_category_id: categoryId,
    name_en: defaultName,
    name_es: defaultName,
    short_description_en: "",
    short_description_es: "",
    size_m2: "",
    beds_count: "",
    max_pax: "",
    bed_type_en: "",
    bed_type_es: "",
    view_en: "",
    view_es: "",
    highlights_en: "",
    highlights_es: "",
  };
}

export function normalizeBookingEngineRoomCopyMap(input) {
  if (!input) return {};

  if (Array.isArray(input)) {
    return input.reduce((accumulator, row) => {
      const normalizedRow = normalizeBookingEngineRoomCopyRow(row);
      if (!normalizedRow?.onboarding_room_category_id) return accumulator;
      accumulator[normalizedRow.onboarding_room_category_id] = normalizedRow;
      return accumulator;
    }, {});
  }

  if (isObject(input)) {
    return Object.entries(input).reduce((accumulator, [key, row]) => {
      const normalizedRow = normalizeBookingEngineRoomCopyRow({
        ...row,
        onboarding_room_category_id: row?.onboarding_room_category_id || Number(key),
      });
      if (!normalizedRow?.onboarding_room_category_id) return accumulator;
      accumulator[normalizedRow.onboarding_room_category_id] = normalizedRow;
      return accumulator;
    }, {});
  }

  return {};
}

export function normalizeBookingEngineRoomAmenities(input) {
  if (!input) return {};

  if (Array.isArray(input)) {
    return input.reduce((accumulator, row) => {
      const categoryId = Number(row?.onboarding_room_category_id || row?.room_category_id || 0);
      if (!categoryId) return accumulator;
      accumulator[categoryId] = normalizeIdArray(
        row?.amenity_ids || row?.selected_amenity_ids || row?.amenities
      );
      return accumulator;
    }, {});
  }

  if (isObject(input)) {
    return Object.entries(input).reduce((accumulator, [key, value]) => {
      const categoryId = Number(key);
      if (!categoryId) return accumulator;
      accumulator[categoryId] = normalizeIdArray(value);
      return accumulator;
    }, {});
  }

  return {};
}

export function normalizeOnboardingRoomCategories(data) {
  const rows = Array.isArray(data?.rows) ? data.rows : Array.isArray(data) ? data : [];
  return rows
    .map((row) => ({
      id: Number(row?.id || 0),
      name: String(row?.name || "").trim(),
      description: String(row?.description || "").trim(),
    }))
    .filter((row) => row.id > 0);
}

export function normalizeAmenitiesRows(data) {
  const rows = Array.isArray(data?.rows) ? data.rows : Array.isArray(data) ? data : [];
  return rows
    .map((row) => ({
      id: Number(row?.id || 0),
      code: String(row?.code || "").trim(),
      name_en: String(row?.name_en || "").trim(),
      name_es: String(row?.name_es || "").trim(),
      category: String(row?.category || "").trim(),
    }))
    .filter((row) => row.id > 0);
}

export function amenityLabel(amenity, languageId) {
  if (!amenity) return "";
  const normalizedLanguage = String(languageId || "").toLowerCase();
  if (normalizedLanguage.startsWith("es") || normalizedLanguage.startsWith("ca")) {
    return amenity.name_es || amenity.name_en || amenity.code || `#${amenity.id}`;
  }
  return amenity.name_en || amenity.name_es || amenity.code || `#${amenity.id}`;
}

export function buildBookingEngineDraftPayload(draft) {
  const source = normalizeBookingEngineDraft(draft);
  return {
    booking_engine_enabled: true,
    booking_engine_slug: String(source.booking_engine_slug || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, ""),
    booking_engine_texts: {
      hero_subtitle: {
        en: String(source.booking_engine_texts?.hero_subtitle?.en || "").trim(),
        es: String(source.booking_engine_texts?.hero_subtitle?.es || "").trim(),
      },
      hero_claim: {
        en: String(source.booking_engine_texts?.hero_claim?.en || "").trim(),
        es: String(source.booking_engine_texts?.hero_claim?.es || "").trim(),
      },
    },
    booking_engine_terms: normalizeBookingEngineTerms(source.booking_engine_terms),
    booking_engine_guest_email_templates: ensureBookingEngineGuestEmailTemplates(source),
    booking_engine_price_includes_vat: Boolean(source.booking_engine_price_includes_vat),
    booking_engine_price_includes_other_taxes: Boolean(source.booking_engine_price_includes_other_taxes),
    booking_engine_price_includes_fees: Boolean(source.booking_engine_price_includes_fees),
    booking_engine_price_includes_city_tax: Boolean(source.booking_engine_price_includes_city_tax),
  };
}

export function buildBookingEngineProfilePayload(profile) {
  const source = normalizeBookingEngineProfile(profile);
  return {
    public_hotel_name: source.public_hotel_name,
    address_line: source.address_line,
    city: source.city,
    postal_code: source.postal_code,
    country: source.country,
    phones: source.phones,
    emails: source.emails,
  };
}

function parseNullableInteger(value) {
  const rawValue = String(value == null ? "" : value).trim();
  if (!rawValue) return null;
  const numericValue = Number(rawValue);
  if (!Number.isFinite(numericValue)) return null;
  return Math.trunc(numericValue);
}

function emptyToNull(value) {
  const rawValue = String(value == null ? "" : value).trim();
  return rawValue ? rawValue : null;
}

export function buildBookingEngineRoomCopyPayload(roomCopyById, categories) {
  return (Array.isArray(categories) ? categories : [])
    .map((category) => {
      const categoryId = Number(category?.id || 0);
      if (!categoryId) return null;
      const draft = normalizeBookingEngineRoomCopyRow(roomCopyById?.[categoryId]) || buildDefaultBookingEngineRoomCopy(category);
      return {
        id: draft.id || null,
        onboarding_room_category_id: categoryId,
        name_en: String(draft.name_en || "").trim(),
        name_es: String(draft.name_es || "").trim(),
        short_description_en: emptyToNull(draft.short_description_en),
        short_description_es: emptyToNull(draft.short_description_es),
        size_m2: parseNullableInteger(draft.size_m2),
        beds_count: parseNullableInteger(draft.beds_count),
        max_pax: parseNullableInteger(draft.max_pax),
        bed_type_en: emptyToNull(draft.bed_type_en),
        bed_type_es: emptyToNull(draft.bed_type_es),
        view_en: emptyToNull(draft.view_en),
        view_es: emptyToNull(draft.view_es),
        highlights_en: emptyToNull(draft.highlights_en),
        highlights_es: emptyToNull(draft.highlights_es),
      };
    })
    .filter(Boolean);
}

export function buildBookingEngineRoomAmenitiesPayload(roomAmenityIdsById) {
  return Object.entries(isObject(roomAmenityIdsById) ? roomAmenityIdsById : {})
    .map(([key, value]) => ({
      onboarding_room_category_id: Number(key),
      amenity_ids: normalizeIdArray(value),
    }))
    .filter((row) => row.onboarding_room_category_id > 0);
}

export function getBookingEngineText(draft, textKey, lang) {
  const source = normalizeBookingEngineDraft(draft);
  return String(source.booking_engine_texts?.[textKey]?.[lang] || "").trim();
}

export function buildBookingEnginePublicUrl(slug) {
  const safeSlug = String(slug || "").trim();
  if (!safeSlug || typeof window === "undefined") return "";
  return `${window.location.origin}/booking/${safeSlug}`;
}

export function buildBookingEngineDisclosurePreview(draft, copy) {
  const flags = {
    vat: Boolean(draft?.booking_engine_price_includes_vat),
    other: Boolean(draft?.booking_engine_price_includes_other_taxes),
    fees: Boolean(draft?.booking_engine_price_includes_fees),
    city: Boolean(draft?.booking_engine_price_includes_city_tax),
  };

  const items = [];
  if (flags.vat) items.push(copy.pricingVatLabel);
  if (flags.other) items.push(copy.pricingOtherTaxesLabel);
  if (flags.fees) items.push(copy.pricingFeesLabel);
  if (flags.city) items.push(copy.pricingCityTaxLabel);

  if (!items.length) return copy.pricingNoneIncluded;
  if (items.length === 4) return copy.pricingAllIncluded;
  if (items.length === 1) return `${copy.pricingIncludingPrefix} ${items[0]}`;
  if (items.length === 2) return `${copy.pricingIncludingPrefix} ${items[0]} ${copy.pricingConjunction} ${items[1]}`;
  return `${copy.pricingIncludingPrefix} ${items.slice(0, -1).join(", ")} ${copy.pricingConjunction} ${
    items[items.length - 1]
  }`;
}

export function buildBookingEngineProfilePreview(profile) {
  const source = normalizeBookingEngineProfile(profile);
  return {
    hotelName: source.public_hotel_name,
    lines: [
      source.address_line,
      [source.postal_code, source.city].filter(Boolean).join(" "),
      source.country,
      source.phones.length ? source.phones.join(" | ") : "",
      source.emails.length ? source.emails.join(" | ") : "",
    ].filter(Boolean),
  };
}

export function normalizeBookingEngineEditorLanguage(languageId) {
  return String(languageId || "").toLowerCase().startsWith("es") ? "es" : "en";
}

export function buildRoomCopyHighlightItems(value) {
  const rawValue = String(value || "").replace(/\r/g, "").trim();
  if (!rawValue) return [];

  let items = rawValue
    .split(/\n+/)
    .map((item) => item.trim())
    .filter(Boolean);

  if (items.length <= 1) {
    items = rawValue
      .split(/[;,]|[·•]/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return items.slice(0, 8);
}

export function buildBookingEngineRoomCopyPreviewData(category, sourceRow, languageId) {
  const safeLanguage = normalizeBookingEngineEditorLanguage(languageId);
  const defaultRow = buildDefaultBookingEngineRoomCopy(category);
  const row = normalizeBookingEngineRoomCopyRow(sourceRow) || defaultRow;

  const localizedName = safeLanguage === "es" ? row.name_es || defaultRow.name_es : row.name_en || defaultRow.name_en;
  const localizedShort =
    safeLanguage === "es" ? row.short_description_es || "" : row.short_description_en || "";
  const localizedBedType = safeLanguage === "es" ? row.bed_type_es || "" : row.bed_type_en || "";
  const localizedView = safeLanguage === "es" ? row.view_es || "" : row.view_en || "";
  const localizedHighlights = safeLanguage === "es" ? row.highlights_es || "" : row.highlights_en || "";

  const specs = [];
  const size = Number(row.size_m2);
  if (Number.isFinite(size) && size > 0) {
    specs.push(`${Math.trunc(size)} m2`);
  }

  const beds = Number(row.beds_count);
  if (Number.isFinite(beds) && beds > 0) {
    specs.push(`${Math.trunc(beds)} ${safeLanguage === "es" ? "camas" : "beds"}`);
  }

  const pax = Number(row.max_pax);
  if (Number.isFinite(pax) && pax > 0) {
    specs.push(`${Math.trunc(pax)} pax`);
  }

  return {
    lang: safeLanguage,
    displayName: String(localizedName || "").trim(),
    shortDescription: String(localizedShort || "").trim(),
    bedType: String(localizedBedType || "").trim(),
    view: String(localizedView || "").trim(),
    highlightItems: buildRoomCopyHighlightItems(localizedHighlights),
    specsLine: specs.join(" / "),
  };
}

export function roomCopyLanguageIsConfigured(category, row, languageId) {
  const preview = buildBookingEngineRoomCopyPreviewData(category, row, languageId);
  return Boolean(
    preview.displayName ||
      preview.shortDescription ||
      preview.bedType ||
      preview.view ||
      preview.highlightItems.length
  );
}

export function renderBookingEngineTemplateValue(templateValue, variables) {
  let output = String(templateValue || "");
  Object.entries(variables || {}).forEach(([key, value]) => {
    output = output.split(`{{${key}}}`).join(value == null ? "" : String(value));
  });
  return output;
}

export function buildBookingEnginePreviewParagraphs(value) {
  return String(value || "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .trim()
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);
}

export function countBookingEngineImages(roomCategoryImages) {
  return Object.values(isObject(roomCategoryImages) ? roomCategoryImages : {}).reduce(
    (total, images) => total + (Array.isArray(images) ? images.length : 0),
    0
  );
}
